<template>
	<div>
		<v-sheet
				class="grey lighten-4"
				:class="$vuetify.breakpoint.smAndDown ? 'pa-4' : 'pa-8'"
				rounded="lg"
		>
			<div class="align-center d-flex justify-space-between pb-2">
				<h5 class="mt-n2">Others Invited</h5>
				<v-btn
						v-if="2 === 3"
						color="secondary"
						depressed
						outlined
						rounded
						:small="$vuetify.breakpoint.mdAndUp"
						:x-small="$vuetify.breakpoint.smAndDown"
				>
					View All
				</v-btn>
			</div>
			<div class="d-flex grey--text mt-n4 text--darken-2 text-caption">
				<div class="flex-grow-1">
					You + {{ invitees.length }} Merchants
					<v-divider class="my-2 opacity-50"></v-divider>
				</div>
			</div>
			<div class="d-flex flex-row">
				<div
						class="align-center d-flex flex-grow-1 invitee-avatars w-100"
						style="height: 64px;"
				>
					<invite-avatars
							:activeAvatar="activeAvatar"
							:avatarSize="$vuetify.breakpoint.smAndDown ? 36 : 48"
							grayscale
							:invite="invite"
							:invitees="invitees"
							@set-active-avatar="setActiveAvatar"
					></invite-avatars>
				</div>
			</div>

			<v-row>
				<v-col class="order-first" cols="12" md="4">
					<h6>{{ labels.merchantName }}</h6>
					<span class="text-caption text-md-body-2">
						{{ invitees[activeAvatar].name }}
					</span>
				</v-col>
				<v-col class="order-last order-sm-1" cols="12" md="4">
					<h6>{{ labels.merchantAddress }}</h6>
					<span class="text-caption text-md-body-2">
						{{ invitees[activeAvatar].address || 'N/A' }}
					</span>
				</v-col>
				<v-col class="order-1 order-sm-last" cols="12" md="4">
					<h6>{{ labels.merchantWebsite }}</h6>
					<a
							v-if="invitees[activeAvatar].website"
							class="text-caption text-md-body-2"
							:href="invitees[activeAvatar].website"
					>
						Visit
					</a>
					<template v-else>
						N/A
					</template>
				</v-col>
			</v-row>

		</v-sheet>
	</div>
</template>

<script>
import { inviteHelpers } from '../../helpers';

export default {
	name: 'PassInvitees',
	props: {
		invite: {
			type: Object,
			default: () => ({})
		}
	},
	data() {
		return {
			activeAvatar: 0,
			inviteHelpers,
			invitees: inviteHelpers.nonDeclinedInvitees(this.invite),
			moreCount: inviteHelpers.getMoreInviteesCount(this.invite)
		};
	},
	computed: {
		labels() {
			const isMdAndDown = this.$vuetify.breakpoint.mdAndDown;
			return {
				merchantName: isMdAndDown ? 'Merchant' : 'Merchant Name',
				merchantAddress: isMdAndDown ? 'Address' : 'Merchant Address',
				merchantWebsite: isMdAndDown ? 'Website' : 'Merchant Website'
			};
		}
	},
	methods: {
		getAvatarSize(idx) {
			const isSmAndDown = this.$vuetify.breakpoint.smAndDown;
			const activeSize = isSmAndDown ? 44 : 64;
			const inactiveSize = isSmAndDown ? 36 : 48;
			return this.activeAvatar === idx ? activeSize : inactiveSize;
		},
		setActiveAvatar(idx) {
			this.activeAvatar = idx;
		}
	}
};
</script>
